// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { unlink16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-unlink': IconUnlink;
    }
}

/**
 * The icon component for the 'unlink' icon
 */
export class IconUnlink extends Icon {
    public constructor() {
        super(unlink16X16);
    }
}

registerIcon('icon-unlink', IconUnlink);
export const iconUnlinkTag = 'nimble-icon-unlink';
